import { apiStore } from '../../../modules/apiHelper';
import { isStaleData, now } from '../../../modules/dataHelper';
import mentor from './mentor';
import mentee from './mentee';
import programMentee from './program-mentee';
import getProgramTask from './get-program-task';
import programMentor from './program-mentor';
import programTaskResources from './program-task-resources';
import badges from './badges';


export default {
  ...mentor,
  ...mentee,
  ...getProgramTask,
  ...programMentee,
  ...programMentor,
  ...programTaskResources,
  ...badges,

  async getTaskDraft(context, userId) {
    const [expiry, draft] = await apiStore.getItem(`draftTask/${userId}`) || [0, [undefined, undefined, undefined, undefined]];

    // expiry of 12 hours
    if (isStaleData(expiry, now(), 43200000)) {
      await apiStore.removeItem(`draftTask/${userId}`);
      return [undefined, undefined, undefined, undefined];
    }

    return draft;
  },

  async getCreateTaskReferencedItem(context, refId) {
    const refItem = await apiStore.getItem(refId);
    return refItem;
  },

  async saveCreateTaskDraft(context, [refId, draftData]) {
    const refItem = await apiStore.setItem(`draftTask/${refId}`, [now(), draftData]);
    return refItem;
  },
};
